const state = {
  user_id: 0,
  name: '',
  email: '',
  picture: '',
  phone_number: '',
  school: '',
  student_number: '',
  birth_date: '',
  grade: '',
  is_active: false,
  is_nf_student: false,
  expired_at: null,
  fitur: null,
  period: []
}

const mutations = {
  usman_init: function(state, payload) {
    state.user_id = payload.user_id
    state.name = payload.name
    state.email = payload.email
    state.picture = payload.picture
    state.phone_number = payload.phone_number
    state.school = payload.school
    state.student_number = payload.student_number
    state.birth_date = payload.birth_date
    state.grade = payload.grade
    state.is_active = payload.is_active
    state.is_nf_student = payload.is_nf_student,
    state.expired_at = payload.expired_at
  },
  usman_set_fitur: function(state, payload) {
    state.fitur = payload
  },
  usman_set_period: function(state, payload) {
    state.period = payload
  },
  usman_set_grade: function(state, payload) {
    state.grade = payload
  }
}

export default {state, mutations}



// WEBPACK FOOTER //
// ./src/store/modules/usman.js